__turbopack_context__.v({
  "className": "inter_4da6be46-module__zr4cAa__className",
});
